// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__SupUX","LayoutWithDesignSwitchLine":"Layout_LayoutWithDesignSwitchLine__ToJ+U","DesktopSidebarContentWrapper":"Layout_DesktopSidebarContentWrapper__JevyN"};